import { ConnectionNames } from "../Contracts";
import { QueryBuilder } from "./Helpers";
import { BaseRESTConnection } from "../Common";
export class SearchConnection extends BaseRESTConnection {
    constructor(meta) {
        super(ConnectionNames.search, meta);
    }
    search(q) {
        return this.applyQuery(QueryBuilder.search(q));
    }
    personalizedEvents(q) {
        return this.applyQuery(QueryBuilder.personalizedEvents(q));
    }
    getEvents(q) {
        return this.applyQuery(QueryBuilder.getEvents(q));
    }
    getLeagues(q) {
        return this.applyQuery(QueryBuilder.getLeagues(q));
    }
}
//# sourceMappingURL=SearchConnection.js.map